import { useFormatExport } from "./useFormatExport.ts";

const FALLBACK_FILE_NAME = "export.csv";

export interface UseCsvExportResult {
    exportCsv: (path: string, input: object) => Promise<boolean>;
    isExporting: boolean;
}

export function useCsvExport(): UseCsvExportResult {
    const { exportFile, isExporting } = useFormatExport(FALLBACK_FILE_NAME);

    return { exportCsv: exportFile, isExporting };
}
